const ACCOUNT_MONITORING_CONFIGS_KEY = 'accountMonitoringConfigs';
const ACCOUNT_OWNER_METADATA_KEY = 'accountOwnerMetadata';
const ACCOUNT_RISK_PROFILE_KEY = 'accountRiskProfile';
const ALL_DISPENSARIES_KEY = 'allDispensaries';
const AUTO_GEN_REVIEWS_KEY = 'autoGenReviews';
const BANK_BENEFICIAL_OWNERS_KEY = 'bankBeneficialOwners';
const BANK_BULK_IMPORTS_KEY = 'bankBulkImports';
const BANK_BULK_IMPORT_BY_ID_KEY = 'bankBulkImportById';
const BANK_DOCUMENTS_KEY = 'bankDocuments';
const BANK_DISPENSARY_KEY = 'bankDispensary';
const BANK_DISPENSARY_INTERNAL_DOCUMENTS_KEY = 'bankDispensaryInternalDocuments';
const BANK_DISPENSARY_AUDIT_TRAIL_EVENTS_KEY = 'bankDispensaryAuditTrailEvents';
const BANK_KEY = 'bank';
const BANKS_KEY = 'allBanks';
const BANK_CRB_TASKS_KEY = 'bankCrbTasks';
const BANK_TASKS_KEY = 'bankTasks';
const BANK_MARKETPLACE_LEADS_KEY = 'bankMarketplaceLeads';
const BANK_QUESTIONNAIRE_KEY = 'bankQuestionnaire';
const BANK_QUESTIONNAIRES_METADATA_KEY = 'bankQuestionnairesMetadata';
const BANK_TEMPLATES_KEY = 'templates';
const BUSINESS_VERIFICATION_KEY = 'businessVerification';
const DATA_POINTS_KEY = 'dataPoints';
const DISPENSARY_KEY = 'dispensary';
const DISPENSARY_BANNER_STATUS_KEY = 'dispensaryBannerStatus';
const DISPENSARY_BENEFICIAL_OWNERS_KEY = 'dispensaryBeneficialOwners';
const DISPENSARY_MARKETPLACE_LEADS_KEY = 'dispensaryMarketplaceLeads';
const DISPENSARY_METADATA_KEY = 'dispensaryMetadata';
const DISPENSARY_S2S_CONFIG_KEY = 'dispensaryS2sConfig';
const DISPENSARY_USERS_KEY = 'dispensaryUsers';
const DOCUMENTS_KEY = 'documents';
const FI_MARKETPLACE_OFFERS_KEY = 'fiMarketplaceOffers';
const FINCEN_EXPORT_RECORD_SUBMISSION_METADATA_KEY = 'fincenExportRecordSubmissionMetadata';
const FINCEN_REPORT_KEY = 'fincenReport';
const FI_TASK_KEY = 'fiTask';
const INGESTION_DATA_KEY = 'ingestionData';
const INSIGHTS_METADATA_KEY = 'insightsMetadata';
const INVITED_DISPENSARIES_KEY = 'invitedDispensaries';
const LICENSES_KEY = 'licenses';
const MAX_DEPOSIT_KEY = 'maxDeposit';
const MESSAGE_TEMPLATES_KEY = 'messageTemplates';
const MINIFIED_DISPENSARIES_KEY = 'minifiedDispensaries';
const MSB_REGISTRATIONS_SEARCH_KEY = 'msbRegistrationsSearch';
const MUOS_KEY = 'muos';
const NEGATIVE_NEWS_KEY = 'negativeNews';
const PRODUCT_CATEGORY_MAP_V2_KEY = 'productCategoryMapV2';
const QUESTIONNAIRE_OVERVIEW_KEY = 'questionnaireOverview';
const REQUEST_REVISION_KEY = 'requestRevision';
const RISK_ASSESSMENTS_KEY = 'riskAssessments';
const RISK_ASSESSMENT_TEMPLATES_KEY = 'riskAssessmentTemplates';
const RISK_BANDS_KEY = 'riskBands';
const SFTP_SALES_PROVIDER_KEY = 'sftpSalesProvider';
const SFTP_SALES_PROVIDERS_KEY = 'sftpSalesProviders';
const BANK_STAFF_KEY = 'bankStaff';
const TEMPLATE_KEY = 'template';
const TEMPLATE_RESULT_KEY = 'templateResult';
const TRANSACTION_CODES_KEY = 'transactionCodes';
const USER_KEY = 'user';
const GC_MANAGED_TEMPLATE_METADATAS_KEY = 'gcManagedTemplateMetadatas';
const CRB_MARKETPLACE_OFFERS_KEY = 'crbMarketplaceOffers';
const DISPENSARY_BUSINESS_STAGE = 'dispensaryBusinessStage';
const BANK_OMIT_TRANSACTIONS_KEY = 'bankOmitTransactions';
const BANK_COUNTERPARTIES_KEY = 'bankCounterparties';
const CORE_TRANSACTIONS_BY_ID_KEY = 'coreTransactionsById';
const COUNTERPARTY_ACTIVITY_KEY = 'counterpartyActivity';
const CRB_COUNTERPARTIES_KEY = 'crbCounterparties';
const CRB_QUESTIONNAIRE_RESULT_KEY = 'crbQuestionnaireResult';

export {
  ACCOUNT_MONITORING_CONFIGS_KEY,
  ACCOUNT_OWNER_METADATA_KEY,
  ACCOUNT_RISK_PROFILE_KEY,
  ALL_DISPENSARIES_KEY,
  AUTO_GEN_REVIEWS_KEY,
  BANK_BENEFICIAL_OWNERS_KEY,
  BANK_BULK_IMPORT_BY_ID_KEY,
  BANK_BULK_IMPORTS_KEY,
  BANK_COUNTERPARTIES_KEY,
  BANK_CRB_TASKS_KEY,
  BANK_DISPENSARY_AUDIT_TRAIL_EVENTS_KEY,
  BANK_DISPENSARY_INTERNAL_DOCUMENTS_KEY,
  BANK_DISPENSARY_KEY,
  BANK_DOCUMENTS_KEY,
  BANK_KEY,
  BANK_MARKETPLACE_LEADS_KEY,
  BANK_OMIT_TRANSACTIONS_KEY,
  BANK_QUESTIONNAIRE_KEY,
  BANK_QUESTIONNAIRES_METADATA_KEY,
  BANK_STAFF_KEY,
  BANK_TASKS_KEY,
  BANK_TEMPLATES_KEY,
  BANKS_KEY,
  BUSINESS_VERIFICATION_KEY,
  CORE_TRANSACTIONS_BY_ID_KEY,
  COUNTERPARTY_ACTIVITY_KEY,
  CRB_COUNTERPARTIES_KEY,
  CRB_MARKETPLACE_OFFERS_KEY,
  CRB_QUESTIONNAIRE_RESULT_KEY,
  DATA_POINTS_KEY,
  DISPENSARY_BANNER_STATUS_KEY,
  DISPENSARY_BENEFICIAL_OWNERS_KEY,
  DISPENSARY_BUSINESS_STAGE,
  DISPENSARY_KEY,
  DISPENSARY_MARKETPLACE_LEADS_KEY,
  DISPENSARY_METADATA_KEY,
  DISPENSARY_S2S_CONFIG_KEY,
  DISPENSARY_USERS_KEY,
  DOCUMENTS_KEY,
  FI_MARKETPLACE_OFFERS_KEY,
  FI_TASK_KEY,
  FINCEN_EXPORT_RECORD_SUBMISSION_METADATA_KEY,
  FINCEN_REPORT_KEY,
  GC_MANAGED_TEMPLATE_METADATAS_KEY,
  INGESTION_DATA_KEY,
  INSIGHTS_METADATA_KEY,
  INVITED_DISPENSARIES_KEY,
  LICENSES_KEY,
  MAX_DEPOSIT_KEY,
  MESSAGE_TEMPLATES_KEY,
  MINIFIED_DISPENSARIES_KEY,
  MSB_REGISTRATIONS_SEARCH_KEY,
  MUOS_KEY,
  NEGATIVE_NEWS_KEY,
  PRODUCT_CATEGORY_MAP_V2_KEY,
  QUESTIONNAIRE_OVERVIEW_KEY,
  REQUEST_REVISION_KEY,
  RISK_ASSESSMENT_TEMPLATES_KEY,
  RISK_ASSESSMENTS_KEY,
  RISK_BANDS_KEY,
  SFTP_SALES_PROVIDER_KEY,
  SFTP_SALES_PROVIDERS_KEY,
  TEMPLATE_KEY,
  TEMPLATE_RESULT_KEY,
  TRANSACTION_CODES_KEY,
  USER_KEY
};
